import React from 'react'
import { Helmet } from 'react-helmet'

const SlConnect = ({ ...props }) => (
  <Helmet {...props}>
    <script type="text/javascript">
      {`
        
        
        (function(s,l,c,o) {
        var b=c.createElement('script');b.async=1;b.src=o;s[l]=s[l]||function(){
        (s[l].q=s[l].q||[]).push(arguments)}; var r=c.getElementsByTagName('script')[0];
        r.parentNode.insertBefore(b, r);
      })(window,'SLC',document,'https://connect.suedtirol.live/slc.js');

        SLC('setup', 'SLC-8GCSJXZB'); 
        
        `}
    </script>
  </Helmet>
)
SlConnect.propTypes = {}
SlConnect.defaultProps = {}
export default SlConnect
